import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import SocieteService from "../../services/Societe";
import { useNavigate } from "react-router-dom";
import ErrorAlert from "../../components/layouts/ErrorAlert";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import SocieteAndUserService from "../../services/societeAndUser";

const ListSocieteAchatFN = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();

  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState("");
  const [idSociete, setIdSociete] = useState("any");

  const [options, setOptions] = useState([{ value: 0, label: "Tous" }]);
  const [yearsOptions, setYearsOptions] = useState([
    { value: "00", label: "Tous" },
  ]);
  const [monthsOptions, setMonthsOptions] = useState([
    { value: "00", label: "Tous" },
  ]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [finalYear, setFinalYear] = useState("");
  const [finalMonth, setFinalMonth] = useState("");
  const [yearPlaceholder, setYearPlaceholder] = useState("");
  const [monthPlaceholder, setMonthPlaceholder] = useState("");
  const [payedOrNotPayed, setPayedOrNotPayed] = useState("any");
  const [document, setDocument] = useState(null);

  const [selectedOptionDocument, setSelectedOptionDocument] = useState("Facture");
  const [selectedOptionPayement, setSelectedOptionPayement] = useState("Payed");
  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          
          const today = new Date();
          const mm = String(today.getMonth() + 1).padStart(2, "0");
          console.log(mm === "08");
          const yyyy = today.getFullYear();
      
          setFinalYear(yyyy);
          setYearPlaceholder(yyyy);
      
          if (mm === "01") {
            setFinalMonth("01");
            setMonthPlaceholder("Janvier");
          } else if (mm === "02") {
            setFinalMonth("02");
            setMonthPlaceholder("Février");
          } else if (mm === "03") {
            setFinalMonth("03");
            setMonthPlaceholder("Mars");
          } else if (mm === "04") {
            setFinalMonth("04");
            setMonthPlaceholder("Avril");
          } else if (mm === "05") {
            setFinalMonth("05");
            setMonthPlaceholder("Mai");
          } else if (mm === "06") {
            setFinalMonth("06");
            setMonthPlaceholder("Juin");
          } else if (mm === "07") {
            setFinalMonth("07");
            setMonthPlaceholder("Juiliet");
          } else if (mm === "08") {
            setFinalMonth("08");
            setMonthPlaceholder("Aout");
          } else if (mm === "09") {
            setFinalMonth("09");
            setMonthPlaceholder("Septembre");
          } else if (mm === "10") {
            setFinalMonth("10");
            setMonthPlaceholder("Octobre");
          } else if (mm === "11") {
            setFinalMonth("11");
            setMonthPlaceholder("Novembre");
          } else if (mm === "12") {
            setFinalMonth("12");
            setMonthPlaceholder("Decemebre");
          }
      
          const yearsOptions = response.data["success"].years.map((year, index) => ({
            value: year,
            label: year,
          }));
          setYearsOptions([{ value: "00", label: "Tous" }, ...yearsOptions]);
      
          const orderedMonth = response.data["success"].months.map((month) => parseInt(month));
          console.log(orderedMonth);
          orderedMonth.sort((a, b) => a - b);
          console.log(orderedMonth);
      
          const monthsOptions = orderedMonth.map((month) => {
            const monthLabel = month < 10 ? `0${month}` : `${month}`;
            switch (month) {
              case 1:
                return { value: monthLabel, label: "Janvier" };
              case 2:
                return { value: monthLabel, label: "Février" };
              case 3:
                return { value: monthLabel, label: "Mars" };
              case 4:
                return { value: monthLabel, label: "Avril" };
              case 5:
                return { value: monthLabel, label: "Mai" };
              case 6:
                return { value: monthLabel, label: "Juin" };
              case 7:
                return { value: monthLabel, label: "Juiliet" };
              case 8:
                return { value: monthLabel, label: "Aout" };
              case 9:
                return { value: monthLabel, label: "Septembre" };
              case 10:
                return { value: monthLabel, label: "Octobre" };
              case 11:
                return { value: monthLabel, label: "Novembre" };
              case 12:
                return { value: monthLabel, label: "Decembre" };
              default:
                return null;
            }
          });
      
          console.log(monthsOptions);
          setMonthsOptions([{ value: "00", label: "Tous" }, ...monthsOptions]);
          // remplissageYearsAndMonthsOption();
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      });
   

    startLoading();

     startLoading();
           SocieteAndUserService.getAllPartenaires( "FOURNISSEUR",0)
            .then((response) => {
              if (Object.keys(response.data)[0] === "ListSociete") {
              setAlertMessage("success");
    
              localStorage.setItem("TypeTiersAccount", "F");
    
              const newOptions = response.data["ListSociete"].map((typeBill) => ({
                value: typeBill.id,
                label: typeBill.title,
              }));
              console.log("newOptions", newOptions);
              setOptions((prevOptions) => [...prevOptions, ...newOptions]);
               
              }
            })
            .catch((e) => {
                      setAlertMessage("error " + e);
    
            }).finally(() => {
            stopLoading();
          });

  }, []);
 

  const onValueDocumentChange = (event) => {
    if (event.target.value === "BDC") {
      setDocument(0);
    } else if (event.target.value === "Facture") {
      setDocument(1);
    }
    setSelectedOptionDocument(event.target.value);
    console.log("selectedOptionDocument", event.target.value);
  };
  const saveIdSociete = () => {
    // isIncome="ACHAT"
    localStorage.setItem("idSociete", idSociete);
    localStorage.setItem("finalMonth", finalMonth);
    localStorage.setItem("finalYear", finalYear);
    localStorage.setItem("payedOrNotPayed", payedOrNotPayed);
    // localStorage.setItem("isIncome", "ACHAT");
    localStorage.setItem("document", 1);
    navigate(`/listBillAchat`);
    
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setIdSociete(selectedOption.value);
  };

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFinalYear(selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const onValueChange = (event) => {
    if (event.target.value === "Payed") {
      setPayedOrNotPayed(1);
    } else if (event.target.value === "NotPayed") {
      setPayedOrNotPayed(0);
    } else if (event.target.value === "All") {
      setPayedOrNotPayed("any");
    }
    setSelectedOptionPayement(event.target.value);
    // console.log("selectedOptionPayement", event.target.value);
  };

  return (
    <div className="content-wrapper"  style={{ marginTop: "0" }}>
      <br/>
      {alertMessage === "error" ? (
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <ErrorAlert message="Désolé aucun Société cliente à afficher, Vous devez ajouter une société svp" />
            </div>
          </div>
        </section>
      ) : (
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Payement des achats</h3>
                </div>
                <form
                  className="form-horizontal"
                  onSubmit={saveIdSociete}
                ></form>
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir le fournisseur</label>
                        <Select
                          value={selectedOption}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={options}
                          onChange={handleChange}
                          defaultValue={selectedOption}
                          placeholder={"Tous"}
                        />
                      </div>
                    </div>

                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir l'année </label>
                        <Select
                          value={selectedYear}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={yearsOptions}
                          onChange={handleYearChange}
                          defaultValue={selectedYear}
                          placeholder={yearPlaceholder}
                        />
                      </div>
                    </div>

                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir le mois</label>
                        <Select
                          value={selectedMonth}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={monthsOptions}
                          onChange={handleMonthChange}
                          defaultValue={selectedMonth}
                          placeholder={monthPlaceholder}
                        />
                      </div>
                    </div>

                    {/* <label>Choisir facture / bon de commande:</label> */}

                    <div
                      className="form-group clearfix col-4 col-sm-12"
                      style={{ marginTop: 20 }}
                    >
                      {/* <div className="radio form-check form-check-inline">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            value="BDC"
                            checked={selectedOptionDocument === "BDC"}
                            onChange={onValueDocumentChange}
                          />
                          Bon de commande
                        </label>
                      </div> */}

                      <div className="radio form-check form-check-inline">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            value="Facture"
                            checked={selectedOptionDocument === "Facture"}
                            onChange={onValueDocumentChange}
                          />
                          Facture
                        </label>
                      </div>
                    </div>

                    <div
                      className="form-group clearfix col-4 col-sm-12"
                      style={{ marginTop: 20 }}
                    >
                      <div className="radio form-check form-check-inline">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            value="Payed"
                            checked={selectedOptionPayement === "Payed"}
                            onChange={onValueChange}
                          />
                          Payées
                        </label>
                      </div>

                      <div className="radio form-check form-check-inline">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            value="NotPayed"
                            checked={selectedOptionPayement === "NotPayed"}
                            onChange={onValueChange}
                          />
                          Non Payées
                        </label>
                      </div>

                      <div className="radio form-check form-check-inline">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            value="All"
                            checked={selectedOptionPayement === "All"}
                            onChange={onValueChange}
                          />
                          Tous
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    onClick={saveIdSociete}
                    className="btn btn-dark float-right"
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default withLoader(ListSocieteAchatFN);
